import { getDataMapper, mapField } from "@/shared";

export const mapDiscountsFiltersDataToServer = getDataMapper({
    search_code: mapField("searchCode"),
    promocode_only: mapField("hasPromocode"),
});
